module.exports = __webpack_public_path__ + "img/entrance.7005286a.jpg";